import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SessionService } from '../Util/Session/session.service';
import { CommonService } from '../Model/Common/common.service';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';

@Component({
  selector: 'app-employee-resign',
  standalone: true,
  imports: [FormsModule, CommonModule, NgSelectModule, NgbDatepickerModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './employee-resign.component.html',
  styleUrl: './employee-resign.component.scss'
})
export class EmployeeResignComponent {
  
  user: any;
  ReasonLoad: any[] = [];
  Trackings = [];
  isApprovalLavel = true;
  TrackingsUser = [];

  Filter = {
    Remark: null,
    isShowError: false,
  }

  DetailData = {
    WebESSApprovalRequestTrackingId: null as any,
    TransactionId: null as any,
    EmpMasterId: null,
    EmpCode: null,
    Photo: null as any,
    EmployeeName: null as any,
    BranchName: null,
    ClientLocation: null,
    DesignationMasterId: null,
    DesignationName: null,
    ShiftMasterId: null,
    ShiftTitle: null,
    EmpType: null as any,
    ApprovalStatus: null as any,
  };

  constructor(
    private session: SessionService,
    public common: CommonService,
    protected tooltip: TooltipService,
  ){
    this.user = session.GetUserDetails();
  }

  ngOnInit(){
    this.employee.empCode = this.user.EmpCode;
    this.employee.empName = this.user.UserName;
    this.employee.requestedDate = this.user.Date;
  }

  

  employee = {
    empCode: '',
    empName: '',
    designation: 'Developer',
    requestedDate: '',
    noticePeriod: '60 Days',
    lastWorkingDay: '25-5-2026',
    reportingManager: 'Ravi Maskar',
    photo: ''
  };

  form = {
    proposedLastWorkingDay: '',
    reason: null,
    remark: ''
  };

  onSubmit(form: any) {
    if (form.valid) {
      const payload = {
        ...this.employee,
        ...this.form
      };
      console.log(payload);
      alert('Resignation Submitted Successfully');
    }else{
      form.submitted = true;
    }
  }

  removeError() {
    this.Filter.isShowError = false;
  }
}
